import type { HelpFile } from '../../types/help'
import { CertificationCampaignsTestIds } from '../../../testids/CertificationCampaignsTestIds'

export const certificationCampaignsHelp: HelpFile = {
  docPage: '/docs/governance/certification-campaigns',
  texts: {
    [CertificationCampaignsTestIds.certificationCampaignsList]:
      'Active and historical certification campaigns — reviewers attest to access assignments within the configured deadline.',
    [CertificationCampaignsTestIds.colPolicy]: 'Certification policy that produced this campaign — defines scope, frequency, and review behaviour.',
    [CertificationCampaignsTestIds.campaignComboboxPolicy]:
      'Certification policy this campaign is based on — its scope, reviewer type, and frequency drive review-item generation. Required.',
  },
}
